const year = {
  getCurrentYear: function () {
    return +(new Date()).getFullYear()
  },
  getYears: function (from = -3, to = 0) {
    let years = []
    let fromYear = this.getCurrentYear() + from
    let toYear = this.getCurrentYear() + to
    for (let currentYear = toYear; currentYear >= fromYear; currentYear--) {
      years.push(currentYear)
    }
    return years
  },
  getYearsOptions: function (from = -3, to = 0) {
    return this.getYears(from, to).map(v => {
      return {id: v, name: v}
    })
  },
  // TODO: remove dublicate code
  // TODO: update all components year forming to it
  getSpecifiedYearsOptions: function (start, end = null, reverse = true) {
    let years = []
    if (!end) {
      end = this.getCurrentYear()
    }
    for (let currentYear = start; currentYear <= end; currentYear++) {
      years.push(currentYear)
    }
    if (reverse) {
      years.reverse()
    }
    return years.map(v => {
      return {id: v, name: v}
    })
  }
}

export default year
